export const getStyle = (ele, attr) => {
    let style = null;
    try {
        if (window.getComputedStyle) {
            style = window.getComputedStyle(ele, null);
        } else {
            style = ele.currentStyle;
        }
        return attr ? style[attr] : style;
    } catch (error) {
        return {};
    }
};

export const getRandomNonPaleRGBColor = () => {
    // --------------------------
    // 步骤1：在HSB模式下生成颜色（更易控制饱和度和明度，避免淡色）
    // H(Hue)：色相，0-360（代表红、橙、黄、绿、蓝、紫等所有颜色）
    // S(Saturation)：饱和度，0.8-1.0（高饱和度，避免淡色，0=灰色，1=纯色相）
    // B(Brightness)：明度，0.4-0.8（适中明度，避免过亮或过暗，1=纯白，0=纯黑）
    // --------------------------
    const hue = Math.random() * 360; // 随机色相（0-360）
    const saturation = 0.8 + Math.random() * 0.2; // 饱和度80%-100%
    const brightness = 0.4 + Math.random() * 0.4; // 明度40%-80%

    // --------------------------
    // 步骤2：将HSB转换为RGB（核心转换逻辑）
    // --------------------------
    const h = hue / 60;
    const s = saturation;
    const b = brightness;

    const i = Math.floor(h);
    const f = h - i;
    const p = b * (1 - s);
    const q = b * (1 - s * f);
    const t = b * (1 - s * (1 - f));

    let r, g, bVal;
    switch (i % 6) {
        case 0:
            r = b;
            g = t;
            bVal = p;
            break;
        case 1:
            r = q;
            g = b;
            bVal = p;
            break;
        case 2:
            r = p;
            g = b;
            bVal = t;
            break;
        case 3:
            r = p;
            g = q;
            bVal = b;
            break;
        case 4:
            r = t;
            g = p;
            bVal = b;
            break;
        case 5:
            r = b;
            g = p;
            bVal = q;
            break;
    }

    // 将0-1的数值转换为0-255的整数（RGB标准范围）
    const red = Math.round(r * 255);
    const green = Math.round(g * 255);
    const blue = Math.round(bVal * 255);

    // --------------------------
    // 步骤3：返回格式化的结果
    // --------------------------
    return {
        r: red,
        g: green,
        b: blue,
        rgb: `rgb(${red}, ${green}, ${blue})`, // RGB字符串（如rgb(255, 0, 100)）
        css: `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`, // 十六进制颜色（如#ff0064）
    };
};
